var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResultsCarrierStrand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 130,
    viewBox: "0 0 102 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.52197 14.7957H39.1643",
    stroke: "#007580",
    strokeWidth: 4.64976,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4504 118.346H54.1831",
    stroke: "#007580",
    strokeWidth: 4.64976,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6602 73.2893H52.6023",
    stroke: "#007580",
    strokeWidth: 4.64976,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94116 55.8997H43.9072",
    stroke: "#007580",
    strokeWidth: 4.64976,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1659 3.52007C11.707 4.26574 12.3518 6.11952 11.6061 7.66059L11.0627 8.78371C9.4897 12.0345 8.05246 19.8256 13.7804 25.5536C18.1915 29.9646 22.7207 33.1205 27.3098 35.9408C28.87 36.8997 30.5159 37.863 32.1877 38.8416C35.2314 40.623 38.3611 42.4548 41.2169 44.402C50.9001 51.0041 59.3198 59.6797 59.3198 73.684C59.3198 77.723 57.7902 81.666 55.6838 85.2111C53.5559 88.7924 50.6586 92.2715 47.4865 95.4696C41.1501 101.858 33.3145 107.527 27.0781 111.061C23.5248 113.074 20.1736 116.207 17.5417 119.213C16.2442 120.696 15.1689 122.093 14.3785 123.219C13.9831 123.783 13.6704 124.262 13.4428 124.635C13.3292 124.822 13.2437 124.971 13.183 125.082C13.1261 125.187 13.1051 125.233 13.1066 125.23L12.6082 126.369C11.922 127.937 10.0942 128.652 8.52578 127.966L6.23962 126.966C4.67117 126.28 3.95599 124.452 4.64221 122.883L5.14233 121.74C5.87441 120.067 8.10957 116.788 10.999 113.487C13.9709 110.091 18.0633 106.175 22.7913 103.496C28.4118 100.311 35.5949 95.1114 41.3131 89.3464C44.1683 86.4678 46.5572 83.5491 48.2087 80.7696C49.8816 77.954 50.6247 75.5733 50.6247 73.684C50.6247 63.9744 45.1079 57.5788 36.3186 51.5861C33.6674 49.7784 31.041 48.2449 28.2138 46.5941C26.487 45.5858 24.6852 44.5337 22.7571 43.3487C17.8605 40.3394 12.7066 36.7764 7.63208 31.7019C-1.81682 22.253 0.856345 9.91379 3.2357 4.99648L3.77915 3.87335C4.52483 2.33229 6.3786 1.6875 7.91966 2.43317L10.1659 3.52007Z",
    fill: "#284993"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0126 5.21761C57.0599 6.57189 56.811 8.51877 55.4567 9.56608L54.4697 10.3293C44.6772 17.9022 23.5583 34.1116 18.6509 37.3832C16.432 38.8625 11.752 43.6468 10.0807 50.2899C8.51982 56.4945 9.39825 65.0422 19.3135 74.9575C26.5252 82.169 33.0123 87.1081 38.8377 91.5432C41.6996 93.7221 44.4017 95.7793 46.9515 97.9247C50.679 101.061 54.0132 104.373 56.3867 108.389C58.8123 112.494 60.11 117.119 60.11 122.693V123.94C60.11 125.652 58.7221 127.04 57.0102 127.04H54.5148C52.8028 127.04 51.4149 125.652 51.4149 123.94V122.693C51.4149 118.583 50.4894 115.501 48.9009 112.813C47.2604 110.036 44.7897 107.469 41.3536 104.578C39.3252 102.871 36.9147 101.032 34.229 98.9819C28.1927 94.3749 20.7664 88.707 13.1652 81.1058C1.34279 69.2834 -0.743019 57.6744 1.64838 48.1686C3.92946 39.1013 10.1183 32.6215 13.8278 30.1485C18.4059 27.0964 39.1815 11.1605 49.1506 3.45109L50.1376 2.68782C51.4918 1.64051 53.4387 1.88936 54.486 3.24363L56.0126 5.21761Z",
    fill: "#FF7F50"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.178 56.7766C101.178 78.2631 83.7596 95.6813 62.2731 95.6813C40.7867 95.6813 23.3684 78.2631 23.3684 56.7766C23.3684 35.2901 40.7867 17.8718 62.2731 17.8718C83.7596 17.8718 101.178 35.2901 101.178 56.7766Z",
    fill: "#60C2A5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2731 92.4439C81.9717 92.4439 97.9405 76.4751 97.9405 56.7766C97.9405 37.078 81.9717 21.1092 62.2731 21.1092C42.5746 21.1092 26.6058 37.078 26.6058 56.7766C26.6058 76.4751 42.5746 92.4439 62.2731 92.4439ZM62.2731 95.6813C83.7596 95.6813 101.178 78.2631 101.178 56.7766C101.178 35.2901 83.7596 17.8718 62.2731 17.8718C40.7867 17.8718 23.3684 35.2901 23.3684 56.7766C23.3684 78.2631 40.7867 95.6813 62.2731 95.6813Z",
    fill: "black",
    fillOpacity: 0.05
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.331,
    cy: 56.9064,
    rx: 28.0576,
    ry: 28.0576,
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.7622 76.038C73.1318 75.8085 81.4672 67.3307 81.4672 56.9061C81.4672 46.4814 73.1318 38.0037 62.7622 37.7742V76.038Z",
    fill: "#60C2A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultsCarrierStrand);
export default __webpack_public_path__ + "static/media/results-carrier-strand.62141899f526432ed401f87f1e3c2454.svg";
export { ForwardRef as ReactComponent };